import React from 'react';
import { Step } from 'react-joyride';

import SZJoyride from '@buyside/components/presentation/Joyride/szJoyride';
import { entityShowJoyrideSteps } from '@buyside/components/presentation/Joyride/EntityShowJoyride/entityShowJoyrideHelper';

import { optOutJoyride, shouldHideJoyride } from '@buyside/util/joyrideUtil';

const joyrideCookieName = 'hideEntityShowJoyride';

const EntityShowJoyride: React.FC = () => {
  if (shouldHideJoyride(joyrideCookieName)) return null;

  const steps: Step[] = [
    entityShowJoyrideSteps.createQuickPosition,
    entityShowJoyrideSteps.buysideConsensus
  ];

  return (
    <SZJoyride
      callback={({ status }): void => optOutJoyride(status, joyrideCookieName)}
      continuous
      disableOverlay
      disableScrolling
      steps={steps}
    />
  );
};

export default EntityShowJoyride;
